import React, { useState } from "react";
import cn from "classnames";

import { Carousel } from "shared/components/Carousel";

import "./PlayPart.scss";

const uiMessages = [
  {
    title: "Gatia",
    subtitle: 'GOLDEN AGE? MORE LIKE RUST BUCKET',
    content:
      "Home to the Gatians – proud, evolved cat-folk... whose world’s rotting. Corpo-towers scrape a filthy sky while the rest fight for scraps in toxic slums. Now, add neuroborn freaks – lab-grown, neural-net enhanced prototypes, discarded like trash. Law? That's whatever the biggest claws dictate. Welcome to the dumpster fire.",
  },
  {
    title: "Miut",
    subtitle: 'YOUR NEURO-GUTTER TO GLORY',
    content:
      "Dumped here? Good. This billion-soul cyberhell churns with backstabbing officials, mutant junkies, and gangs selling lead & flesh. You? A fresh neuroborn reject, starting broke, bare-clawed, deep in its toxic bowels. Your ascent begins in the shit.",
  },
  {
    title: "Neuroborn",
    subtitle: 'FACTORY DEFECT. FUTURE KINGPIN',
    content:
      "Spawned in a vat, tossed on Miut's scrapheap. Your \"gifts\"? Razor claws, hyper-reflexes, neural hacks – everything they dumped you for. No pedigree. No credits. Just rage, tech, and zero fucks given. Your empire starts with one clawmark.",
  },
  {
    title: "Enemies",
    subtitle: 'CALL THEM XP & LOOT BAGS',
    content:
      "Shank rival gangers for creds. Put down rabid mutants for parts. Carve your rep in turf wars or sell your blade to syndicates. Scavenge corpse-filled ruins for rare blueprints. Danger? That's just uncashed opportunity.",
  },
  {
    title: "Factions",
    subtitle: 'YOUR LADDER OUT OF THE GUTTER (OR INTO A THRONE)',
    content:
      "Whore your skills to the highest bidder. Corner neuro-drug markets. Snap up NFT land & factories – then hire suckers to grind for you. Flip filthy creds for shiny crypto-tokens. Claw, scheme, or buy your way to syndicate godfather. The top gorges on the bottom. Be the chef.",
  },
];

export const PlayPart: React.FC = React.memo(() => {
  const [playButtonHover, setPlayButtonHover] = useState(false);
  const [activeImage, setActiveImage] = useState(0);
  const disabled = false;
  const openGame = () => {
    window.open('https://game.neuroborncats.com/', '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="play-part">
      <Carousel onChange={setActiveImage}>
        <div className="picture-wrapper">
          <div
            className={cn(["picture-1", activeImage === 0 && "with-animation"])}
          />
        </div>

        <div className="picture-wrapper">
          <div
            className={cn(["picture-2", activeImage === 1 && "with-animation"])}
          />
        </div>

        <div className="picture-wrapper">
          <div
            className={cn(["picture-3", activeImage === 2 && "with-animation"])}
          />
        </div>

        <div className="picture-wrapper">
          <div
            className={cn(["picture-4", activeImage === 3 && "with-animation"])}
          />
        </div>

        <div className="picture-wrapper">
          <div
            className={cn(["picture-5", activeImage === 4 && "with-animation"])}
          />
        </div>
      </Carousel>
      <div className="play-part__content">
        <div className="play-part__content_title">Neuroborn Cats: The Game</div>
        <div
          className={[
            "play-part__content_button",
            playButtonHover && "hovered",
            disabled && "disabled",
          ]
            .filter(Boolean)
            .join(" ")}
          onMouseEnter={() => {
            !disabled && setPlayButtonHover(true);
          }}
          onMouseLeave={() => {
            !disabled && setPlayButtonHover(false);
          }}
          onClick={() => {openGame()}}
        >
          <div
            className="play-part__content_button--label"
          >
            <span>{disabled ? "COMING SOON" : "PLAY"}</span>
          </div>
        </div>
        <div className="play-part-info">
          <div className="play-part-info__title">
            {uiMessages[activeImage].title}
          </div>
          <div className="play-part-info__content">
            <p className="play-part-info__subtitle">{uiMessages[activeImage].subtitle}</p>
            <p className="play-part-info__text">{uiMessages[activeImage].content}</p>
          </div>
        </div>
      </div>
    </div>
  );
});
